export var USER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
export var USER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';
